import { useState } from "react";
import { useAuthHeader, useAuthUser } from "../../../../Services/Auth/sessionAuth";
import { Button, Form, Space, Radio, Spin, Tabs } from 'antd';
import Table from '../../../TableResizable';
import Utilisateur from "../../../../Models/Utilisateur";
import type { TabsProps } from 'antd';
import { UserOutlined, ContactsOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import SweetAlert from "sweetalert2";
import Swal from "sweetalert2";
import Tab1 from "./Tab1";
import { Box, Typography } from '@mui/material';
import DataType from "../../../../Functions/Traitement/DataPeriodMVirement";
import { ColumnsType } from "antd/es/table";
import Data from '../../../../Data/Data.json';
import { Crypter } from "../../../../Functions/Security/Crypter";
import axios from "axios";
import SearchModal from "../../../SearchModal";
import RadioBox from "../../../Radiox";
import InputForm from "../../../InputT";





const ValidEInvalidVp = () => {

    const auth = useAuthUser()
    const Perss: Utilisateur = JSON.parse(JSON.stringify(auth()))
    const authHeader = useAuthHeader()
    const [Onfinis, SetOnfinis] = useState<number>(0);
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [SearchGlobal, setSearchGlobal] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [Consultactv, setConsulte] = useState(false);
    const [Ajoutactv, setAjoute] = useState(false);
    const [Modifactv, setModife] = useState(true);
    const [Supprimactv, setSupprime] = useState(true);
    const [Enregactv, setEnrege] = useState(true);
    const [Actuactv, setActue] = useState(true);
    const [Annulactv, setAnnule] = useState(true);
    const [FormAct, setFormactve] = useState(true);
    const [sbmit, setSbmit] = useState("")

    // Handle pour la selection des element dans le tableau
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);

    // function pour la selection du tab
    const onSelectChange = (newSelectedRowKeys: any) => {
        console.log('selectedRowKeys changed :) ', donnees[newSelectedRowKeys]);
        setSelectedRowKeys(newSelectedRowKeys);

        sessionStorage.clear();
        sessionStorage.setItem(Data.LocalVariable.FirstValueAuto, Crypter.encrypt(donnees[newSelectedRowKeys].NUMDOS));
    };

    const rowSelection = {
        onChange: onSelectChange,
        selectedRowKeys,
    };

    const [checkboxValues, setCheckboxValues] = useState({
        checkbox1: false,
        checkbox2: false,
        checkbox3: false,
    });
    function handleCheckboxChange(events = require('events')) {
        const { name, checked } = events.target;
        setCheckboxValues({ ...checkboxValues, [name]: checked });

    }

    // usestate pour remplir le tableau
    const [donnees, setData] = useState<DataType[]>([]);


    function HandleAnnul() {
        setSelectedRowKeys([]);
        setData([])
        form.resetFields();
        setSbmit('');

        localStorage.setItem(Data.LocalVariable.reset, "1")
        localStorage.setItem(Data.LocalVariable.Mainreset, "1")
        localStorage.clear();
    }



    // GESTION DES ITEMS
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: (
                <span id='x'>
                    <UserOutlined />
                    Validation virement permanent
                </span>
            ),
            children: <Tab1 />,
        },
    ];

    //state pour la recherche
    const [SearchR, SetSearchR] = useState<string>("");

    //column du tableau
    const columns: ColumnsType<DataType> = [
        {
            title: 'Numéro dossier',
            dataIndex: 'NUMDOS',
            filteredValue: [SearchR],
            onFilter: (value: any, record: any) => {
                return String(record.NUMDOS)
                    .toLowerCase()
                    .includes(value.toLowerCase()) ||
                    String(record.CPTDEB)
                        .toLowerCase()
                        .includes(value.toLowerCase()) ||
                    String(record.CPTCRE)
                        .toLowerCase()
                        .includes(value.toLowerCase())
            }
        },
        {
            title: 'Compte débit',
            dataIndex: 'CPTDEB',
        },
        {
            title: 'Compte crédit',
            dataIndex: 'CPTCRE',
        },
        {
            title: 'Montant',
            dataIndex: 'MONTAN',
        },
        {
            title: 'Crée par',
            dataIndex: 'UTISAI',
        },
        {
            title: 'Agence',
            dataIndex: 'codage',
        }, {
            title: 'Crée le',
            dataIndex: 'DATSAI',
        }, {
            title: 'Date imputation',
            dataIndex: 'DATIMP',
        }, {
            title: 'Date arrêt imput',
            dataIndex: 'DATARRIMP',
        },
        //STACHQ

    ];

    // function consult tableableau
    function Consultableau() {
        setSelectedRowKeys([]);
        let a = Perss.codage;
        let b = '1';

        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.AllVirementPerme,
            headers: {
                'CypherCodeage': Crypter.encrypt(a),
                'CypherTrie': Crypter.encrypt(b),
                'Authorization': authHeader(),
                'Content-Type': 'application/json',
            },
        };

        // MAPPING DANS LE TABLEAU
        let dat: DataType[] = [];
        axios.request(config)
            .then((response) => {
                setLoading(false);
              
                if (response.data) {
                    let datas = JSON.parse(JSON.stringify((response.data.Result?.Table || []))); //response.data.Result?.Table || [];//response.data.Result//JSON.parse(JSON.stringify((response.data.Result)));
                    if (datas[0] == null) {
                        SweetAlert.fire({ title: "Il ne possède pas de Vp en attente de validation", icon: "warning" })
                    } else {

                    }
                    // console.log(response.data)
                 //   setData(response.data).

                    datas.map((val: any, key: any) => {
                        dat.push({
                            key: key,
                            NUMDOS: val.NUMDOS,
                            CODOPE: val.CODOPE,
                            DATSAI: val.DATSAI,
                            DATIMP: val.DATIMP,
                            CPTDEB: val.CPTDEB,
                            LIBCPTDEB: val.LIBCPTDEB,
                            CPTCRE: val.CPTCRE,
                            LIBCPTCRE: val.LIBCPTCRE,
                            MONTAN: val.MONTAN,
                            FREQIMP: val.FREQIMP,
                            NBRIMP: val.NBRIMP,
                            DECOUV: val.DECOUV,
                            DATARRIMP: val.DATARRIMP,
                            UTISAI: val.UTISAI,
                            UTIMOD: val.UTIMOD,
                            DATMOD: val.DATMOD,
                            IsFRAIS: val.IsFRAIS,
                            MONTAN1: val.MONTAN1,
                            MONTAN2: val.MONTAN2,
                            MONTAN3: val.MONTAN3,
                            MONTAN4: val.MONTAN4,
                            LIBELL1: val.LIBELL1,
                            LIBELL2: val.LIBELL2,
                            LIBELL3: val.LIBELL3,
                            LIBELL4: val.LIBELL4,
                            CODOP1: val.CODOP1,
                            CODOP2: val.CODOP2,
                            CODOP3: val.CODOP3,
                            CODOP4: val.CODOP4,
                            codage: val.codage,
                            cdetat: val.cdetat,
                            utival: val.utival,
                            isbloqAuto: val.isbloqAuto,
                            datval: val.datval,
                            //motif: val.motif,
                        })
                    })
                    //setData(dat)
                    //console.log(datas)
                    setData(dat)
                } else {
                    SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false);
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
    }


    // function consult 2

    function Consultableau2() {
        setSelectedRowKeys([]);
        let a = Perss.codage;
        let b = '1';

        setLoading(true)
        let config = {
            method: 'get',
            maxBodyLength: Infinity,
            url: Data.ApiUrl.AllVirementPerme,
            headers: {
                'CypherCodeage': Crypter.encrypt(a),
                'CypherTrie': Crypter.encrypt(b),
                'Authorization': authHeader(),
                'Content-Type': 'application/json',
            },
        };

        // MAPPING DANS LE TABLEAU
        let dat: DataType[] = [];
        axios.request(config)
            .then((response) => {
                setLoading(false);

                if (response.data) {
                    let datas =JSON.parse(JSON.stringify((response.data.Result?.Table || []))); //JSON.parse(JSON.stringify((response.data.Result)));
                    if (datas[0] == null) {
                        
                    } else {

                    }

                    datas.map((val: any, key: any) => {
                        dat.push({
                            key: key,
                            NUMDOS: val.NUMDOS,
                            CODOPE: val.CODOPE,
                            DATSAI: val.DATSAI,
                            DATIMP: val.DATIMP,
                            CPTDEB: val.CPTDEB,
                            LIBCPTDEB: val.LIBCPTDEB,
                            CPTCRE: val.CPTCRE,
                            LIBCPTCRE: val.LIBCPTCRE,
                            MONTAN: val.MONTAN,
                            FREQIMP: val.FREQIMP,
                            NBRIMP: val.NBRIMP,
                            DECOUV: val.DECOUV,
                            DATARRIMP: val.DATARRIMP,
                            UTISAI: val.UTISAI,
                            UTIMOD: val.UTIMOD,
                            DATMOD: val.DATMOD,
                            IsFRAIS: val.IsFRAIS,
                            MONTAN1: val.MONTAN1,
                            MONTAN2: val.MONTAN2,
                            MONTAN3: val.MONTAN3,
                            MONTAN4: val.MONTAN4,
                            LIBELL1: val.LIBELL1,
                            LIBELL2: val.LIBELL2,
                            LIBELL3: val.LIBELL3,
                            LIBELL4: val.LIBELL4,
                            CODOP1: val.CODOP1,
                            CODOP2: val.CODOP2,
                            CODOP3: val.CODOP3,
                            CODOP4: val.CODOP4,
                            codage: val.codage,
                            cdetat: val.cdetat,
                            utival: val.utival,
                            isbloqAuto: val.isbloqAuto,
                            datval: val.datval
                        })
                    })
                    setData((dat))
                    console.log(dat)
                } else {
                    SweetAlert.fire({ title: "Error", text: "Aucun Element dans le tableau", icon: "warning" })
                }
                setLoading(false)
            })
            .catch((error) => {
                setLoading(false);
                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
            });
    }


    // function Onfinish
    const onFinish = (values: any) => {

        if (selectedRowKeys.length == 0) {
            SweetAlert.fire({ title: " selectionner un Vp", text: "", icon: "warning" })
        } else {

            console.log(sbmit)
            if (sbmit == 'valid') {
                let NUMDOS = (((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('2')


                SweetAlert.fire({
                    title: "Valider VP",
                    text: "Voulez-vous valider le Vp du dossier N°: " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidVirementPerme,
                            headers: {
                                'CypherNUMDOS': NUMDOS,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    //console.log(res)    Ovalide
                                    //console.log(res)
                                    let code = res.Message
                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même User ne peut validé le Vp", icon: "warning" })
                                    } else if (code == 'Ovalide') {
                                        SweetAlert.fire({ title: " ", text: "Vp déjà valide ", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Vp validé N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        //HandleActualiser()
                                    }
                                    setSelectedRowKeys([]);
                                    Consultableau2();
                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })
            } else if (sbmit == "invalid") {
                let NUMDOS = (((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "")
                //alert(NUMDEMANDE);
                let data2 = Crypter.encrypt(Perss.coduti)
                let data3 = Crypter.encrypt(Perss.datjour)
                let data4 = Crypter.encrypt(Perss.codage)
                let data5 = Crypter.encrypt('3')


                SweetAlert.fire({
                    title: "Rejeter VP",
                    text: "Voulez-vous Rejeter le Vp du dossier N°: " + (Crypter.decrypt((sessionStorage.getItem(Data.LocalVariable.FirstValueAuto) + '')) + "") + " ?",
                    showCancelButton: true,
                    color: "green",
                    confirmButtonText: "Yes",
                    confirmButtonColor: "green",
                    cancelButtonColor: "darkred",
                    cancelButtonText: "No",
                    showLoaderOnConfirm: true,
                    icon: 'question'
                }).then((res) => {
                    if (res.isConfirmed) {
                        setLoading(true);
                        setIsSubmit(true)
                        let config = {
                            method: 'put',
                            maxBodyLength: Infinity,
                            url: Data.ApiUrl.ValidInvalidVirementPerme,
                            headers: {
                                'CypherNUMDOS': NUMDOS,
                                'CypherUTIVAL': data2,
                                'CypherDATVAL': data3,
                                'Cyphercodeage': data4,
                                'Cyphertrie': data5,
                                'Authorization': authHeader(),
                                'Content-Type': 'application/json'
                            },
                        };

                        axios.request(config)
                            .then((response) => {
                                setLoading(false);
                                if (response.data) {
                                    const res = JSON.parse(Crypter.decrypt(response.data));
                                    //console.log(res)    Ovalide
                                    //console.log(res)
                                    let code = res.Message
                                    if (code == 'ErrorUser') {
                                        SweetAlert.fire({ title: " ", text: "le même User ne peut Invalidé le Vp", icon: "warning" })
                                    } else if (code == 'Invalide') {
                                        SweetAlert.fire({ title: " ", text: "Vp déjà Rejeter ", icon: "warning" })
                                    } else {
                                        setIsSubmit(false)
                                        SweetAlert.fire({ title: " ", text: "Vp Rejeter N°:" + code, icon: "success" })
                                        localStorage.clear()
                                        form.resetFields()
                                        //HandleActualiser()
                                    }
                                    setSelectedRowKeys([]);
                                    Consultableau2();

                                }
                            })
                            .catch((error) => {
                                setLoading(false);
                                SweetAlert.fire({ title: "Error", text: error, icon: "error" })
                            });
                    }
                })

            }

        }

    }




    // function de verification 
    const onFinishFailed = async (errorInfo: any) => {
        var errors: any = [];
        errorInfo.errorFields.map((error: any) => {
            errors.push(error.name + "");
        })

        SweetAlert.fire({ title: "Veuillez remplir tous les champs obligatoires", text: errors.toString().replaceAll(',', " - "), icon: 'warning', confirmButtonText: 'OK' })
    };

    const verifSubmit = () => {
        if (!isSubmit) {
            Swal.fire({ title: "Attention", text: "Veillez remplir tous les champs", icon: "warning" })
        }
    };



    return (
        <div className='tab'>
            <Typography align='center' className='formTitle'> <b> {window.location.pathname} </b> </Typography>
            <Spin spinning={loading} size='large' style={{ color: 'green' }}>
                <Form disabled={FormAct} autoComplete="off" labelAlign='left' form={form} name="dynamic_form_complex" onFinish={onFinish} onFinishFailed={onFinishFailed} style={{ minWidth: 'auto', maxWidth: 'auto' }}>
                    <div className='bG'>
                        <legend><Typography color={"darkgreen"}>Actions</Typography></legend>
                        <Form.Item shouldUpdate className='bouttong'>
                            <Space direction="vertical" style={{ width: '100%' }}>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { Consultableau() }} type="ghost" block>
                                    Afficher
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('valid') }} type="ghost" htmlType="submit" block>
                                    Valider
                                </Button>
                                <Button size='large' className='bt_add' disabled={false} onClick={() => { setSbmit('invalid') }} type="ghost" htmlType="submit" block>
                                    Rejeter
                                </Button>
                            </Space>
                        </Form.Item>
                    </div>
                    <div className='clientP'>
                        <div>
                            <div >
                                <Tabs size='large' type="card" defaultActiveKey="1" items={items} />
                            </div>
                            <div className='tabItem' >
                                <div style={{ display: 'block flow' }}  >
                                    <Box fontStyle="inherit" className='border' width={"85%"} position={"absolute"} sx={{ p: 1 }} >
                                        <legend> Validation des ordres de virement permanent </legend>
                                        <Box style={{ display: 'flex' }} fontStyle="inherit" className='border' width={"100%"} sx={{mb:1}} >
                                            
                                            <Box style={{  marginTop: -5,marginBottom:0    }}  width={"100%"} sx={{mb:1}}>
                                                <InputForm disabled={false} notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'Recherche'} width={100} name="Element" type="string" />
                                             
                                            </Box>

                                            {/* <Box style={{ width: 600, right: 10, position: 'fixed', marginRight: '16%', marginBottom: 20 }}  >
                                                <InputForm disabled={false} notRequired onChange={(e: any) => { SetSearchR(e.target.value.trim()); }} label={'recherche'} name="Element" type="string" taille={500} />
                                            </Box> */}
                                            
                                        </Box>
                                        <Box  fontStyle="inherit" className='border'  width={"100%"}>
                                               <Spin spinning={loading}>
                                                    <Table dataSource={donnees} rowSelection={{ ...rowSelection, type: "radio", getCheckboxProps: (reccord) => ({ disabled: false }) }} columns={columns} style={{ textAlign: "center", width: '100%' }} size='small' pagination={false} scroll={{ y: 400, x: 400 }} />
                                                </Spin>
                                            </Box>
                                    </Box>
                                </div>
                            </div>
                        </div>
                    </div>
                </Form>
            </Spin>
        </div>
    );
}

export default ValidEInvalidVp;